import {
  NewCategoryHandbook,
  UserToLandlordCategoryHandbook,
  ToPlatformCategoryHandbook,
} from "../handbooks/categoryHandbook";
import { NewOfficeHandbook } from "../handbooks/officeHandbook";
import { PriorityHandbook } from "../handbooks/priorityHandbook";
import { NewRenterHandbook } from "../handbooks/renterHandbook";
import { StatusHandbook } from "../handbooks/statusHandbook";
import { NewCurrencyHandbook } from "../handbooks/service/currencyHandbook";
import { NewUserRoleHandbook } from "../handbooks/userRoleHandbook";

export type InputType =
  | "text"
  | "password"
  | "email"
  | "datetime-local"
  | "textarea"
  | "phone"
  | "user-role"
  | "renter"
  | "category"
  | "user-to-landlord-category"
  | "to-platform-category"
  | "office"
  | "boolean"
  | "datepicker"
  | "currency"
  | "priority"
  | "status";

export const handbookMap: Record<string, React.ComponentType<any>> = {
  office: NewOfficeHandbook,
  renter: NewRenterHandbook,
  "user-role": NewUserRoleHandbook,
  category: NewCategoryHandbook,
  "user-to-landlord-category": UserToLandlordCategoryHandbook,
  "to-platform-category": ToPlatformCategoryHandbook,
  currency: NewCurrencyHandbook,
  priority: PriorityHandbook,
  status: StatusHandbook,
};
